import { ApiResponse } from '@/models/ApiResponse';
import { ReportFile } from '@/models/ReportFile';
import {
  RunDealContingentPayload,
  RunRatesDealContingentPayload,
  SaveUserWidgetDealContingentPayload,
} from '@/pages/DealContingentAnalysis/store/types';
import { AxiosInstance, AxiosResponse } from 'axios';

export default class IRAnalysisAPI {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }
  async saveUserWidgetData(
    payload: SaveUserWidgetDealContingentPayload,
  ): Promise<AxiosResponse<ApiResponse<any>>> {
    return this.client.post('/v2/user/save-user-widget-data/', payload);
  }

  async runDealContingent(
    payload: RunDealContingentPayload,
  ): Promise<AxiosResponse<ApiResponse<ReportFile>>> {
    const url = '/v2/hedging/run-deal-contingent/';
    return this.client.post(url, payload);
  }

  /**
   * The rates counterpart of `runDealContingent`. It prices a trade that is
   * already booked, so the schedule comes from the transaction rather than the
   * request (RATES_DEAL_CONTINGENT_REPORT_API.md).
   */
  async runRatesDealContingent(
    payload: RunRatesDealContingentPayload,
  ): Promise<AxiosResponse<ApiResponse<ReportFile>>> {
    const url = '/v2/hedging/run-rates-deal-contingent/';
    return this.client.post(url, payload);
  }
}
